import { useCallback } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

import { flowCardActionsStore, type FlowCardActionsStoreState } from './FlowCardActionsStore.ts';
import { selectData, selectById, selectIsLoading } from '../selectors.ts';

import { useAttach } from '../useAttach.js';

export function useFlowCardActionsData() {
  useAttach(flowCardActionsStore, 'useFlowCardActionsData');
  return useStoreWithEqualityFn(flowCardActionsStore.store, selectData, shallow);
}
useFlowCardActionsData.store = flowCardActionsStore;

export function useFlowCardActionsById() {
  useAttach(flowCardActionsStore, 'useFlowCardActionsById');
  return useStoreWithEqualityFn(flowCardActionsStore.store, selectById, shallow);
}
useFlowCardActionsById.store = flowCardActionsStore;

export function useFlowCardAction({ flowCardActionId }: { flowCardActionId: string }) {
  useAttach(flowCardActionsStore, 'useFlowCardAction');

  const select = useCallback(
    (state: FlowCardActionsStoreState) => {
      return {
        flowCardAction: state.byId?.[flowCardActionId] ?? null,
        flowCardActionInstance: state.data?.[flowCardActionId] ?? null,
        isLoading: state.isLoading,
        error: state.error,
      };
    },
    [flowCardActionId]
  );

  return useStoreWithEqualityFn(flowCardActionsStore.store, select, shallow);
}
useFlowCardAction.store = flowCardActionsStore;

export function useFlowCardActionsAttach() {
  useAttach(flowCardActionsStore, 'useFlowCardActionsAttach');
}
useFlowCardActionsAttach.store = flowCardActionsStore;

export function useFlowCardActionsLoading() {
  useAttach(flowCardActionsStore, 'useFlowCardActionsLoading');
  return useStoreWithEqualityFn(flowCardActionsStore.store, selectIsLoading, Object.is);
}
useFlowCardActionsLoading.store = flowCardActionsStore;
